module.exports = __webpack_public_path__ + "static/media/signal-4.dc9d3050.svg";